<template>
  <div>
    <Gs1AlertCompanyInactive
      v-if="companyIsInactive"
      :gs1Id="gs1Id"
      :gtinsVerifiedResponse="this.gtinsVerifiedResponse"
      :glnsVerifiedResponse="this.glnsVerifiedResponse"
      :mainLicensesVerifiedResponse="this.mainLicensesVerifiedResponse"
    />
    <gs1-alert-verified
      v-else-if="saveGet(product, false, 'isComplete')"
      :companyName="
        saveGet(this.gtinsVerifiedResponse.gs1Licence, '', 'licenseeName')
      "
      :gs1Id="saveGet(product, '', 'gtin')"
    >
    </gs1-alert-verified>
    <gs1-alert
      v-else
      alertClass="success"
      iconClass="fa fa-check-circle color-forest"
    >
      <p>
        {{
          $t('alert.some_data.title', {
            company: saveGet(
              this.gtinsVerifiedResponse.gs1Licence,
              '',
              'licenseeName'
            ),
            epc: gs1Id
          })
        }}
      </p>
      <i18n path="alert.some_data.message" tag="p" class="small">
        <a
          href="https://www.gs1-germany.de/service/kontakt/"
          target="_blank"
          rel="noopener"
          >{{ $t('alert.some_data.contact_gs1') }}</a
        >
      </i18n>
    </gs1-alert>
    <div class="row">
      <div class="col-lg-12 col-xs-12">
        <!-- Nav tabs -->
        <ul class="nav nav-tabs" style="padding-left: 0px" role="tablist">
          <li v-if="product" role="presentation" :class="productActive">
            <a href="#product" role="tab" data-toggle="tab">
              {{ $t('product') }}
            </a>
          </li>

          <li v-if="licence" role="presentation" :class="licenceActive">
            <a href="#company" role="tab" data-toggle="tab">
              {{ $t('company') }}
            </a>
          </li>

          <li
            v-if="digitalLocation"
            role="presentation"
            :class="digitalLocationActive"
          >
            <a href="#digital" role="tab" data-toggle="tab">
              {{ $t('digital_location') }}
            </a>
          </li>

          <li
            v-if="functionType"
            role="presentation"
            :class="functionTypeActive"
          >
            <a href="#functionType" role="tab" data-toggle="tab">
              {{ $t('function') }}
            </a>
          </li>

          <li v-if="legalEntity" role="presentation" :class="legalEntityActive">
            <a href="#legal" role="tab" data-toggle="tab">
              {{ $t('legal_entity') }}
            </a>
          </li>

          <li
            v-if="fixedPhysicalLocation"
            role="presentation"
            :class="fixedPhysicalLocationActive"
          >
            <a href="#fixed" role="tab" data-toggle="tab">
              {{ $t('fixed_physical_location') }}
            </a>
          </li>

          <li
            v-if="mobilePhysicalLocation"
            role="presentation"
            :class="mobilePhysicalLocationActive"
          >
            <a href="#mobile" role="tab" data-toggle="tab">
              {{ $t('mobile_physical_location') }}
            </a>
          </li>
        </ul>

        <!-- Tab panes -->
        <div class="tab-content">
          <!-- Product -->
          <div
            v-if="product"
            role="tabpanel"
            class="tab-pane active"
            id="product"
            style="width: 100%; overflow-x: auto"
            :class="productActive"
          >
            <Product
              :product="product"
              :status="productStatus"
              :linkSet="gtinLinkSet"
            />
          </div>

          <!-- Company -->
          <div
            v-if="licence"
            role="tabpanel"
            class="tab-pane"
            id="company"
            style="width: 100%; overflow-x: auto"
            :class="licenceActive"
          >
            <Licence
              :show-map="true"
              :licence="licence"
              :mainLicensesVerifiedResponse="mainLicensesVerifiedResponse"
            />
          </div>

          <!-- Digital -->
          <div
            v-if="digitalLocation"
            role="tabpanel"
            class="tab-pane"
            id="digital"
            style="width: 100%; overflow-x: auto"
          >
            <DigitalLocation
              :digitalLocation="digitalLocation"
              :status="digitalLocationStatus"
              :linkSet="glnLinkSet"
            />
          </div>

          <!-- Function -->
          <div
            v-if="functionType"
            role="tabpanel"
            class="tab-pane"
            id="functionType"
            style="width: 100%; overflow-x: auto"
          >
            <FunctionType
              :show-map="true"
              :functionType="functionType"
              :status="functionTypeStatus"
              :linkSet="glnLinkSet"
            />
          </div>

          <!-- Legal -->
          <div
            v-if="legalEntity"
            role="tabpanel"
            class="tab-pane"
            id="legal"
            style="width: 100%; overflow-x: auto"
          >
            <LegalEntity
              :show-map="true"
              :legalEntity="legalEntity"
              :status="legalEntityStatus"
              :linkSet="glnLinkSet"
            />
          </div>

          <!-- Fixed -->
          <div
            v-if="fixedPhysicalLocation"
            role="tabpanel"
            class="tab-pane"
            id="fixed"
            style="width: 100%; overflow-x: auto"
          >
            <FixedPhysicalLocation
              :show-map="true"
              :fixedPhysicalLocation="fixedPhysicalLocation"
              :status="fixedPhysicalLocationStatus"
              :linkSet="glnLinkSet"
            />
          </div>

          <!-- Mobile -->
          <div
            v-if="mobilePhysicalLocation"
            role="tabpanel"
            class="tab-pane"
            id="mobile"
            style="width: 100%; overflow-x: auto"
          >
            <MobilePhysicalLocation
              :mobilePhysicalLocation="mobilePhysicalLocation"
              :status="mobilePhysicalLocationStatus"
              :linkSet="glnLinkSet"
            />
          </div>
        </div>
      </div>
    </div>

    <p class="footnote">
      {{
        $t('provided_by', [
          saveGet(this.gtinsVerifiedResponse.gs1Licence, '', 'licenseeName')
        ])
      }}
    </p>
  </div>
</template>

<script>
import Gs1Alert from '@/components/alerts/Gs1Alert'
import Gs1AlertVerified from '@/components/alerts/Gs1AlertVerified'
import LangString from '@/components/LangString'
import Lightbox from '@/components/Lightbox'
import DigitalLocation from '@/components/DigitalLocation'
import FunctionType from '@/components/FunctionType'
import LegalEntity from '@/components/LegalEntity'
import FixedPhysicalLocation from '@/components/FixedPhysicalLocation'
import MobilePhysicalLocation from '@/components/MobilePhysicalLocation'
import Licence from '@/components/Licence'
import Product from '@/components/Product'
import { saveGet } from '../mixins/saveGet'
import { mapProduct } from '../mixins/mapProduct'
import digitalLocation from './DigitalLocation'
import functionType from './FunctionType'
import legalEntity from './LegalEntity'
import fixedPhysicalLocation from './FixedPhysicalLocation'
import mobilePhysicalLocation from './MobilePhysicalLocation'
import { isArray } from 'lodash/lang'
import Gs1AlertCompanyInactive from './alerts/Gs1AlertCompanyInactive.vue'

export default {
  name: 'ResultData',
  props: [
    'gtinsVerifiedResponse',
    'glnsVerifiedResponse',
    'gs1Id',
    'mainLicensesVerifiedResponse'
  ],
  components: {
    DigitalLocation,
    FunctionType,
    LegalEntity,
    FixedPhysicalLocation,
    MobilePhysicalLocation,
    Product,
    Licence,
    Gs1Alert,
    Gs1AlertVerified,
    Gs1AlertCompanyInactive,
    LangString,
    Lightbox
  },
  mixins: [saveGet, mapProduct],
  data() {
    return {
      showLightbox: false
    }
  },
  computed: {
    productStatus() {
      return this.gtinsVerifiedResponse.gtinRecordStatus
        ? this.gtinsVerifiedResponse.gtinRecordStatus
        : 'ACTIVE'
    },
    gtinLinkSet() {
      return this.gtinsVerifiedResponse.linkset
    },
    glnLinkSet() {
      const re = this.saveGet(this.glnsVerifiedResponse, null, 0, 'linkset')
      console.log(
        'Getting linkset from',
        this.glnsVerifiedResponse,
        'yields',
        re
      )

      return re
    },
    companyIsInactive() {
      if (this.gtinsVerifiedResponse.gtinRecordStatus === 'INACTIVE') {
        return true
      }

      return this.glnsVerifiedResponse
        ? this.glnsVerifiedResponse.some(g =>
          g.glnRecords
            ? g.glnRecords.some(r => r.glnRecordStatus === 'INACTIVE')
            : false
        )
        : false
    },
    legalEntityStatus() {
      if (this.companyIsInactive) {
        return null
      }

      return this.saveGet(this.legalEntity, null, 'glnRecordStatus')
    },
    functionTypeStatus() {
      if (this.companyIsInactive) {
        return null
      }

      return this.saveGet(this.functionType, null, 'glnRecordStatus')
    },
    digitalLocationStatus() {
      if (this.companyIsInactive) {
        return null
      }

      return this.saveGet(this.digitalLocation, null, 'glnRecordStatus')
    },
    fixedPhysicalLocationStatus() {
      if (this.companyIsInactive) {
        return null
      }

      return this.saveGet(this.fixedPhysicalLocation, null, 'glnRecordStatus')
    },
    mobilePhysicalLocationStatus() {
      if (this.companyIsInactive) {
        return null
      }

      return this.saveGet(this.mobilePhysicalLocation, null, 'glnRecordStatus')
    },
    productActive() {
      return this.product ? 'active' : ''
    },
    product() {
      console.log('gtinsVerifiedResponse', this.gtinsVerifiedResponse)
      if (!this.saveGet(this.gtinsVerifiedResponse, null, 'gpcCategoryCode')) {
        return null
      }
      return this.mapProduct(this.gtinsVerifiedResponse)
    },
    licenceActive() {
      return !this.product && this.licence ? 'active' : ''
    },
    licence() {
      return this.saveGet(this.gtinsVerifiedResponse, null, 'gs1Licence')
    },
    mainlicence() {
      return this.saveGet(this.gtinsVerifiedResponse, null, 'mainLicenses')
    },
    digitalLocationActive() {
      return !this.product && !this.licence && digitalLocation ? 'active' : ''
    },
    legalEntityActive() {
      return !this.product &&
        !this.licence &&
        !this.digitalLocation &&
        legalEntity
        ? 'active'
        : ''
    },
    fixedPhysicalLocationActive() {
      return !this.product &&
        !this.licence &&
        !digitalLocation &&
        fixedPhysicalLocation
        ? 'active'
        : ''
    },
    mobilePhysicalLocationActive() {
      return !this.product &&
        !this.licence &&
        !this.digitalLocation &&
        mobilePhysicalLocation
        ? 'active'
        : ''
    },
    digitalLocation() {
      let glnRecords = this.saveGet(
        this.glnsVerifiedResponse,
        null,
        0,
        'glnRecords'
      )

      if (!isArray(glnRecords) || glnRecords.length < 1) {
        return null
      }

      return glnRecords.find(record => record.glnType === 'DIGITAL_LOCATION')
    },
    legalEntity() {
      let glnRecords = this.saveGet(
        this.glnsVerifiedResponse,
        null,
        0,
        'glnRecords'
      )

      if (!isArray(glnRecords) || glnRecords.length < 1) {
        return null
      }

      return glnRecords.find(record => record.glnType === 'LEGAL_ENTITY')
    },
    functionTypeActive() {
      return !this.product && !this.licence && !digitalLocation && functionType
        ? 'active'
        : ''
    },
    functionType() {
      let glnRecords = this.saveGet(
        this.glnsVerifiedResponse,
        null,
        0,
        'glnRecords'
      )

      if (!isArray(glnRecords) || glnRecords.length < 1) {
        return null
      }

      return glnRecords.find(record => record.glnType === 'FUNCTION')
    },
    fixedPhysicalLocation() {
      let glnRecords = this.saveGet(
        this.glnsVerifiedResponse,
        null,
        0,
        'glnRecords'
      )

      if (!isArray(glnRecords) || glnRecords.length < 1) {
        return null
      }

      return glnRecords.find(
        record => record.glnType === 'FIXED_PHYSICAL_LOCATION'
      )
    },
    mobilePhysicalLocation() {
      let glnRecords = this.saveGet(
        this.glnsVerifiedResponse,
        null,
        0,
        'glnRecords'
      )

      if (!isArray(glnRecords) || glnRecords.length < 1) {
        return null
      }

      return glnRecords.find(
        record => record.glnType === 'MOBILE_PHYSICAL_LOCATION'
      )
    }
  },
  i18n: {
    messages: {
      de: {
        alert: {
          all_data: {
            title: 'Vollständige Informationen',
            message:
              'Die EAN/GTIN bzw. GLN ist unter der Firma {company} registriert.'
          },
          some_data: {
            title:
              'Die EAN/GTIN bzw. GLN {epc} ist unter der Firma {company} registriert, folgende Informationen stehen zur Verfügung:',
            message: 'Bitte {0} wenn Sie Hilfe benötigen.',
            contact_gs1: 'kontaktieren Sie GS1'
          }
        },
        provided_by: 'Diese Daten wurden von {0} zur Verfügung gestellt.',
        legal_entity: 'Juristische Person',
        function: 'Funktion',
        fixed_physical_location: 'Feste physische Lokation',
        mobile_physical_location: 'Mobile physische Lokation',
        digital_location: 'Digitale Lokation',
        company: 'Firma',
        product: 'Produkt'
      },
      en: {
        alert: {
          all_data: {
            title: 'Complete data',
            message: 'This EAN/GTIN or GLN is registered to {0}'
          },
          some_data: {
            title:
              'The EAN/GTIN or GLN {epc} is registered to {company}, and some data is available.',
            message: 'Please {0} if you need help.',
            contact_gs1: 'contact GS1'
          }
        },
        provided_by: 'This data has been provided by {0}.',
        legal_entity: 'Legal Entity',
        function: 'Function',
        fixed_physical_location: 'Fixed Physical Location',
        mobile_physical_location: 'Mobile Physical Location',
        digital_location: 'Digital Location',
        company: 'Company',
        product: 'Product'
      }
    }
  }
}
</script>

<style scoped>
.toolkit .content-module-wrapper {
  margin-bottom: 18px;
}

.toolkit .content-module {
  padding: 20px;
}

.toolkit .content-module .pull-left.img {
  width: 25%;
}

.toolkit .content-module .pull-left.table {
  padding-left: 20px;
  margin-bottom: 0;
  width: 75%;
}

.toolkit .content-module .img-responsive {
  object-fit: contain;
}

.toolkit .content-module .img-responsive.lightbox {
  cursor: pointer;
  transition: 0.3s;
}

.toolkit .content-module .img-responsive.lightbox:hover {
  opacity: 0.75;
}

.toolkit .content-module .table-responsive {
  padding-top: 16px;
}

.toolkit .content-module table {
  margin: 0;
  table-layout: fixed;
}

.toolkit .content-module td,
.toolkit .content-module th {
  border-bottom: 1px solid var(--gs1-light-gray-shade);
  color: var(--gs1-dark-gray);
  line-height: 16px;
  font-size: 14px;
  font-weight: normal;
  padding: 5px 0;
}

.toolkit .content-module td {
  color: var(--gs1-blue);
  font-weight: bold;
}

.toolkit .content-module td.overflow-hidden {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.toolkit .content-module td a {
  color: var(--gs1-blue);
  font-weight: bold;
  text-decoration: none;
  word-wrap: break-word;
  text-overflow: ellipsis;
}

.toolkit .content-module td a:hover {
  color: var(--gs1-link);
}

.toolkit .content-module td .unknown {
  color: var(--gs1-dark-medium-gray);
  font-weight: normal;
}

.toolkit .content-module th {
  padding-right: 35px;
  white-space: nowrap;
}

.toolkit .footnote {
  font-size: 12px;
}

.nav.nav-tabs a {
  color: #002c6c !important;
  text-decoration: none;
}

.nav.nav-tabs a:hover {
  color: #f26334 !important;
}

.nav.nav-tabs a:focus {
  outline: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ResultData.vue